var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGridView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 10.833c.428 0 .78.322.828.736l.006.098v6.666c0 .428-.322.78-.736.828l-.098.006H1.667a.833.833 0 0 1-.828-.736l-.006-.098v-6.666c0-.428.322-.78.736-.828l.098-.006h6.666zm10 0c.428 0 .78.322.828.736l.006.098v6.666c0 .428-.322.78-.736.828l-.098.006h-6.666a.833.833 0 0 1-.828-.736l-.006-.098v-6.666c0-.428.322-.78.736-.828l.098-.006h6.666zM7.5 12.5h-5v5h5v-5zm10 0h-5v5h5v-5zM8.333.833c.428 0 .78.322.828.736l.006.098v6.666c0 .428-.322.78-.736.828l-.098.006H1.667a.833.833 0 0 1-.828-.736l-.006-.098V1.667c0-.428.322-.78.736-.828l.098-.006h6.666zm10 0c.428 0 .78.322.828.736l.006.098v6.666c0 .428-.322.78-.736.828l-.098.006h-6.666a.833.833 0 0 1-.828-.736l-.006-.098V1.667c0-.428.322-.78.736-.828l.098-.006h6.666zM7.5 2.5h-5v5h5v-5zm10 0h-5v5h5v-5z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGridView);
export default __webpack_public_path__ + "static/media/icon-grid-view.537079b2.svg";
export { ForwardRef as ReactComponent };